import { useEffect, useState } from 'react'
import { getSchedule } from 'store/attendance/schedule'
import { useDispatch } from 'react-redux'
import ScheduleTable from 'components/Schedule'

export default function ScheduleList({ schoolEnrollmentId, campusId, memberId, markingPeriodId }) {
  const dispatch = useDispatch()

  const [studentCourseSessionEnrollment, setStudentCourseSessionEnrollment] = useState()
  const [scheduledSessions, setScheduledSessions] = useState()
  const [unScheduledSessions, setUnscheduledSessions] = useState()
  const [startRenderList, setStartRenderList] = useState()
  const [errorMessage, setErrorMessage] = useState()

  // const courseEnrollmentFromStore = useSelector(state => state.academic.schedule.list)

  const studentCourseSessionEnrollmentFetch = async () => {
    // const data = await dispatch(search({ schoolEnrollmentId }))
    // if (data?.payload?.length) {
    //   setStudentCourseSessionEnrollment(data.payload)
    // }
    // if (!courseEnrollmentFromStore) {
      const data = await dispatch(getSchedule({ memberId, type: 'staff', markingPeriodId }))
      if (data?.payload?.length) {
        setStudentCourseSessionEnrollment(data.payload)
      } else {
        setErrorMessage('There is not any Course Enrollment')
      }
    // } else {
    //   setStudentCourseSessionEnrollment(courseEnrollmentFromStore)
    // }
  }

  useEffect(() => {
    if (!memberId || !markingPeriodId) return

    studentCourseSessionEnrollmentFetch()
  }, [schoolEnrollmentId, campusId, markingPeriodId, memberId])

  useEffect(() => {
    if (studentCourseSessionEnrollment?.length > 0) {
      let temp = []
      const rawScheduledSessions = studentCourseSessionEnrollment?.filter(
        item => item.courseSession?.schedules?.length > 0,
      )
      rawScheduledSessions.forEach(item => {
        item.courseSession.schedules.forEach(scheduleItem => {
          const newItem = {
            id: item.courseSession.id,
            name: item.courseSession.course.name + ' - ' + item.courseSession.name,
            startTime: scheduleItem.period.startTime,
            endTime: scheduleItem.period.endTime,
            dayOfWeek: scheduleItem.day,
            periodId: scheduleItem.period.id,
            room: scheduleItem?.room?.id
              ? scheduleItem?.room
              : item?.courseSession?.room?.id
              ? item?.courseSession?.room
              : null,
          }
          temp = addSessionToSchedule(newItem, temp)
        })
      })
      setScheduledSessions(temp)
      setErrorMessage('')
      setUnscheduledSessions(
        studentCourseSessionEnrollment?.filter(item => item.courseSession?.schedules?.length === 0),
      )

    } else if (studentCourseSessionEnrollment?.length === 0) {
      setErrorMessage('There is not any Course Enrollment')
    }
  }, [studentCourseSessionEnrollment])

  const addSessionToSchedule = (newItem, storage) => {
    if (storage.length === 0) {
      storage.push({
        startTime: newItem.startTime,
        endTime: newItem.endTime,
        dayOfWeek: newItem.dayOfWeek,
        periodId: newItem.periodId,
        list: [{ id: newItem.id, name: newItem.name, room: newItem.room }],
      })
      return storage
    }
    let existsIndex = -1
    storage.forEach((item, index) => {
      if (
        item.startTime === newItem.startTime &&
        item.endTime === newItem.endTime &&
        item.dayOfWeek === newItem.dayOfWeek &&
        item.periodId === newItem.periodId
      ) {
        if (existsIndex === -1) existsIndex = index
      }
    })

    if (existsIndex === -1) {
      storage.push({
        startTime: newItem.startTime,
        endTime: newItem.endTime,
        dayOfWeek: newItem.dayOfWeek,
        periodId: newItem.periodId,
        list: [{ id: newItem.id, name: newItem.name, room: newItem.room }],
      })
      return storage
    } else {
      const temp = storage[existsIndex]
      temp.list.push({ id: newItem.id, name: newItem.name, room: newItem.room })
      storage[existsIndex] = temp
      return storage
    }
  }

  useEffect(() => {
    setStartRenderList(true)
  }, [scheduledSessions])

  if (!(startRenderList && scheduledSessions && !errorMessage)) return null

  return (
    <ScheduleTable
      unScheduledSessions={unScheduledSessions}
      scheduledSessions={scheduledSessions}
    />
  )
}
